export default __webpack_public_path__ + "media/1f218d0785d4c1cd6ae271190445ad5e74e1dbe28a42f5564256a64677a1efe2.svg";